import ComingSoon from "./ComingSoon";

function About() {
    return (
      <div>
        <ComingSoon />
      </div>
    );
  }
  
  export default About;
  